module.exports = __webpack_public_path__ + "img/sign_220270567_1.7356121e.png";